@charset "UTF-8";

/* src/app/forms/json-importer/json-importer.component.scss */
.card-header {
  margin: 10px;
}
.headerRow {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 17px;
  margin-left: 14px;
}
.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 16px;
  padding: 0 10px;
}
.param-info {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #555;
  gap: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.execute-button .btn-content {
  display: flex;
  align-items: center;
  gap: 6px;
}
.execute-button mat-icon {
  font-size: 20px;
  vertical-align: middle;
}
.execute-button .btn-label {
  line-height: 20px;
}
.card-actions-row {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.btn-label {
  margin-left: 8px;
}
.integration-header {
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  text-align: center;
}
.integration-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.status-info {
  margin-top: 10px;
  font-size: 13px;
  text-align: center;
  color: #555;
  min-height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.error-info {
  display: flex;
  align-items: center;
  gap: 6px;
}
.error-icon {
  font-size: 20px;
  cursor: pointer;
}
.error-copy-link {
  font-size: 12px;
  padding: 0;
  min-width: unset;
  height: auto;
  text-transform: none;
}
.param-modal-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
}
.param-modal-content {
  max-height: 500px;
  overflow: auto;
  padding: 20px !important;
}
.param-name {
  font-weight: 500;
  font-size: 15px;
  color: #3f51b5;
}
.param-input {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.full-width {
  width: 100%;
}
.param-modal-actions {
  border-top: 1px solid;
  margin-left: 10px;
  margin-right: 10px;
}
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 20px 10px;
}
.config-card {
  width: 280px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  transition: box-shadow 0.3s ease;
  padding: 10px;
  overflow: visible;
  min-height: 340px;
}
.config-card img[mat-card-image] {
  width: 100%;
  object-fit: contain;
  background-color: #f9f9f9;
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
  margin-top: 10px;
  height: 185px;
}
.config-card:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.no-image {
  margin-top: 10px;
  height: 185px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f3f3;
  color: #999;
  font-size: 40px;
  border-bottom: 1px solid #e0e0e0;
}
.container-fluid {
  width: 100%;
  padding: 20px;
}
::ng-deep .full-screen-dialog .mat-dialog-container {
  padding: 0 !important;
  height: 100vh !important;
  width: 100vw !important;
  max-width: 100vw !important;
  border-radius: 0 !important;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
}
.mat-mdc-tab-body.mat-tab-body-active {
  height: 60vh;
}
.block {
  animation: 1s fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
  animation: fadeIn 10s;
  animation-delay: 40s;
  animation-fill-mode: forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.content {
  padding: 5px;
  height: 100%;
}
.mktplace {
  overflow: auto;
  height: 100%;
}
.toogleTest {
  margin-left: 14px;
  margin-top: 6px;
}
.gridclass {
  height: 100%;
  width: 100%;
  position: absolute;
}
.mat-tab-body-content {
  height: auto !important;
}
.tabcontent {
  height: 100%;
  overflow-y: auto;
}
.cardcontent {
  height: 25%;
}
.my-button-class {
  height: 36px;
  line-height: 36px;
}
.margin-top10 {
  margin-top: 10px;
}
.align-items {
  align-items: center;
}
.mat-mdc-tab-group {
  height: 100%;
}
:host ::ng-deep .custom-tabs {
}
:host ::ng-deep .custom-tabs .mat-tab-body-wrapper {
  height: 100%;
}
.transformimage {
  transform: scale(1.5);
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 100% !important;
}
.button-margin {
  margin-right: 10px;
  margin-bottom: 5px;
}
.mat-toolbar {
  background: rgba(0, 0, 0, 0.03) !important;
}
.combined-tab .mat-tab-body-wrapper {
  display: flex;
}
.combined-tab .mat-tab-body-wrapper > div {
  flex: 1;
}
.mat-grid-tile {
  display: flex;
  justify-content: center;
}
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.grid-container {
  flex: 1;
  display: flex;
}
.grid-item {
  flex: 1;
}
.view-component-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content-tab {
  flex: 1;
  display: flex;
  margin-top: 5px;
}
.simple-datagrid {
  flex: 1;
}
.separator {
  height: 1px;
  background-color: #ccc;
  margin: 10px 0;
}
.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.config-info {
  display: flex;
  align-items: center;
  font-size: 114%;
}
.config-label {
  font-weight: bold;
  margin-right: 5px;
}
.config-values {
  color: #333;
}
.config-separator {
  margin: 0 5px;
  color: #777;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.view-component {
  margin: 10px;
  overflow: auto;
}
.directory-class {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: baseline;
}
/*# sourceMappingURL=json-importer.component.css.map */
